<div nz-col nzSpan="24">
  <nz-spin nzTip="Loading..." [nzSize]="'large'" [nzSpinning]="isLoading">
    <div class="file-movement">
      <div class="content">
        <app-data-table [rows]="fileList" [headers]="headers"></app-data-table>
      </div>
    </div>
  </nz-spin>
</div>
